
export enum CashType 
{
    BasketValue = "BasketValue",
    DesiredDeposit = "DesiredDeposit",
    ReceivedDeposit = "ReceivedDeposit",
    Expense = "Expense",
    ReceivedIncome = "ReceivedIncome",
    ReturnedDeposit = "ReturnedDeposit",
}
